export const  getMarketNftsLive = () => {
    return [];
}

export const getMarketNftsLiveById = () => {
    return null;
}

